import { COOKIE_NAME } from '@packages/domain/constants/cookies';
import { EU_COUNTRY_CODES } from '@packages/domain/constants/geolocation';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import { useGeolocation } from 'hooks/useGeolocation/useGeolocation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentLocale, isEmbedded } from 'selectors/ui/ui';
import { cookies } from 'utils/cookies/cookies';
import { useTranslations } from 'utils/translations/useTranslations';

import './CookiesBanner.scss';

const CookiesBanner = () => {
  const [hasCookie, setHasCookie] = useState<boolean>(() =>
    Boolean(cookies.read(COOKIE_NAME)),
  );
  const i18n = useTranslations();
  const locale = useSelector(getCurrentLocale);
  const { cookiePolicyUrl } = useFlysiteUrls(locale);
  const isEmbeddedView = useSelector(isEmbedded);
  const { isLoading, data } = useGeolocation();
  const isEUMember = data ? EU_COUNTRY_CODES.includes(data.countryCode) : false;

  const handleClick = () => {
    cookies.set(COOKIE_NAME, true);
    setHasCookie(true);
  };

  if (isLoading || isEmbeddedView) {
    return null;
  }

  const shouldShowCookieBanner = !hasCookie && isEUMember;

  const link = (
    <a
      href={cookiePolicyUrl}
      title={i18n.t('cookiesBanner.linkTitle')}
      target="_blank"
      rel="noopener noreferrer"
      className="underline"
    >
      {i18n.t('cookiesBanner.linkTitle')}
    </a>
  );

  return (
    shouldShowCookieBanner && (
      <div
        className="CookiesBanner"
        role="dialog"
        aria-describedby="CookiesBanner-content"
        aria-label="Cookie Law"
      >
        <button
          type="button"
          className="CookiesBanner-close"
          onClick={handleClick}
          aria-label="Close"
          data-testid="cookiesBannerButton"
        />
        <div id="CookiesBanner-content">
          {i18n.t('cookiesBanner.description')} {link}
        </div>
      </div>
    )
  );
};

export { CookiesBanner };
